import React, { CSSProperties } from 'react'
import Icon from '@Components/Icon'
import Tooltip from '@Components/Tooltip'
import messages from '@Modules/hubs/main/messages'
import styled from 'styled-components'
import { IntlShape } from 'react-intl/src/types'
import { HubFormattedMessage } from 'src/common/rtl/HubTextFormatting'

type Props = {
  valueToCopy: string
  style?: CSSProperties
  intl: IntlShape
  includeTooltip?: boolean
}

const CopyLink: React.FC<Props> = (props: Props) => {
  const { style, valueToCopy, includeTooltip = true } = props
  const handleCopy = () => {
    if (navigator.clipboard) {
      navigator.clipboard.writeText(valueToCopy)
    } else {
      const textField = document.createElement('textarea')
      textField.innerText = valueToCopy
      document.body.appendChild(textField)
      textField.select()
      document.execCommand('copy')
      textField.remove()
    }
  }

  return (
    <Container style={style} onClick={handleCopy}>
      {includeTooltip ? (
        <Tooltip
          position="TOP_CENTER"
          displayText={<HubFormattedMessage {...messages.copyMemberId} />}
        >
          <Icon type="content" size={18} />
        </Tooltip>
      ) : (
        <Icon type="content" size={18} />
      )}
    </Container>
  )
}

const Container = styled.div``

export default CopyLink
